// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3KMWn","active":"NavigationItem_active__3_eN3"};